import React, { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

export type BoxTagVariantsType =
  | 'div'
  | 'section'
  | 'main'
  | 'aside'
  | 'article'
  | 'header'
  | 'footer'
  | 'span'
  | 'nav'
  | 'ul'
  | 'video';

// TODO: Random TS fix for VideoCarousel
export interface BoxProps extends Omit<HTMLAttributes<Element>, 'onProgress'> {
  /** Sets the HTML tag for the Box Component. */
  as?: BoxTagVariantsType;
  /** The children to be rendered. */
  children?: ReactNode | ReactNode[];
  /** Allows the component to get additional styles. */
  className?: string;
  /** HTML id for Box Component. */
  id?: string;
  /** Sets the role for the Box Component. */
  role?: string;
  /** Sets the tabIndex for the Box Component. */
  tabIndex?: number;
}

const StyledBox = styled('div', {
  shouldForwardProp: isPropValid,
})();

const Box = forwardRef<HTMLDivElement, BoxProps>(({ className, ...rest }, forwardedRef) => (
  <StyledBox ref={forwardedRef} {...rest} className={className} />
));

export { Box };
export default Box;
